import React, { useState } from 'react';
import './index.scss';
import RtcPlayer from '../VideoPlayer/RtcPlayer';
export enum Direction {
  FRONT = '前',
  RIGHT = '右',
  BACK = '后',
  LEFT = '左',
}
interface VideoSource {
  url: string;
  direction: Direction;
}

interface QuadVideoPlayerProps {
  videoSources: VideoSource[];
}

const VideoPlayer: React.FC<{
  source: VideoSource;
  isMain: boolean;
  onVideoClick: () => void;
}> = ({ source, isMain, onVideoClick }) => {
  return (
    <div
      className={`video-container ${isMain ? 'main' : 'side'}`}
      onClick={onVideoClick}
    >
      {source.url ? (
        <RtcPlayer videoUrl={source.url} />
      ) : (
        <div className="video-load-failed">
          <img
            src={require('@/assets/images/mutilVehicle/video-failed.png')}
            alt="Video failed"
          />
          <i>无法获取视频</i>
        </div>
      )}
      <span className="direction">{source.direction}</span>
    </div>
  );
};

const QuadVideoPlayer: React.FC<QuadVideoPlayerProps> = ({ videoSources }) => {
  const [mainVideoIndex, setMainVideoIndex] = useState(0);

  const handleVideoClick = (index: number) => {
    if (index !== mainVideoIndex) {
      setMainVideoIndex(index);
    }
  };

  return (
    <div className="quad-video-container">
      <div className="main-video">
        <VideoPlayer
          source={videoSources[mainVideoIndex]}
          isMain={true}
          onVideoClick={() => {}}
        />
      </div>
      <div className="side-videos">
        {videoSources.map(
          (source, index) =>
            index !== mainVideoIndex && (
              <VideoPlayer
                key={source.direction}
                source={source}
                isMain={false}
                onVideoClick={() => handleVideoClick(index)}
              />
            )
        )}
      </div>
    </div>
  );
};

export default QuadVideoPlayer;
